export const _getContainerElThrowable = (self) => {
  if (self._container_el == null) {
    throw new Error(`container 엘리먼트가 없습니다.`);
  }
  return self._container_el;
};
